export default "__VITE_ASSET__DWQv7OMy__"